module.exports = __webpack_public_path__ + "img/fr.f85e9b61.svg";